import React from "react";
import { Flex, Text } from "@radix-ui/themes";

interface LoadingStateProps {
  message: string;
}

export function LoadingState({ message }: LoadingStateProps) {
  return (
    <Flex
      align="center"
      justify="center"
      style={{ height: "100vh" }}
    >
      <Text>{message}</Text>
    </Flex>
  );
}
